export class BackupPolicyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "processing",
            "baseName": "processing",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<BackupSchedule>",
            "format": ""
        },
        {
            "name": "isSecurityScanEnabled",
            "baseName": "isSecurityScanEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "policyType",
            "baseName": "policyType",
            "type": "BackupPolicyType",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "awsNativePitrConfig",
            "baseName": "awsNativePitrConfig",
            "type": "AwsNativePitrConfig",
            "format": ""
        },
        {
            "name": "bigQueryNativePitrConfig",
            "baseName": "bigQueryNativePitrConfig",
            "type": "BigQueryNativePitrConfig",
            "format": ""
        },
        {
            "name": "nativeStandardConfig",
            "baseName": "nativeStandardConfig",
            "type": "NativeStandardConfig",
            "format": ""
        },
        {
            "name": "azureFilesConfig",
            "baseName": "azureFilesConfig",
            "type": "AzureFilesBackupPolicyPlan",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
